import React, { Component } from 'react';
import {withRouter} from "react-router";
import connect from "react-redux/es/connect/connect";
import * as galleryActions from "../../actions/gallery";

import MainLayout from "../common/MainLayout";
import ReactImageFallback from "react-image-fallback";
import AudioItem from "../includes/Slider/AudioItem";
import * as vignetsActions from "../../actions/vignets";
import AuthService from "../../lib/AuthService";
import {Dropdown, DropdownItem, DropdownMenu, DropdownToggle} from "reactstrap";
import GraphicItem from "../gallery/GraphicItem";
import Slider from "../includes/Slider";
import PropTypes from "prop-types";
import OverviewContainer from "../overview/OverviewContainer";
import VignetContainer from "./VignetContainer";
import VignetDetailContainer from "./DetailContainer";
import GraphicsContainer from "../gallery/GraphicsContainer";
import PlaylistContainer from "../playlist/PlaylistContainer";
import PlaylistDetailContainer from "../playlist/DetailContainer";
import UserContainer from "../user/UserContainer";
import HeaderBar from "../common/HeaderBar";
import LeftMenu from "../common/LeftMenu";
import RightContentHeader from "../common/RightContentHeader";
import FilterBar from "../common/FilterBar";
import {
    Button,
    Form,
    FormFeedback,
    FormGroup,
    Input,
    Label,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader
} from "reactstrap";

class Gallery extends Component {

    constructor(props) {
        super(props);
        this.state = {
            gal_type: 'MY_UPLOADS',
            drop_typ : false,
			g_typ : 'IMG',
            showModal : false,
            wrapClass : 'right-bottom-area',
            imagesList :[],
            redirect: false,
            loader : true,
            view_type:'Image',
            dropdownOpen : false

        };
        this.Auth = new AuthService();
        this.showVgallery = this.showVgallery.bind(this);
        this.showModal = this.showModal.bind(this);
    }
    componentWillMount() {

        let data = {"type" : this.state.gal_type};
        this.props.setGalleryType(data);
    }

    componentDidMount() {

        let data ={
            'userid' : this.Auth.getProfile().user_id,
            'le_id' : this.props.vigntid
        }

        this.props.getGalleryList(data);

       /* let gdet ={
            'itemid' : this.props.vigntid,
            'userid' : this.Auth.getProfile().user_id
        }
        this.props.getGalleryDetails(gdet);*/


        /*let gdata = {"gal_type" : 'MY_UPLOADS', userid : this.Auth.getProfile().user_id,size:50,offset:0};
        this.props.allGalleryData(gdata);*/

        let wrap_class = 'gallery-main-wrap';
        switch('MY_UPLOADS') {
            case 'MY_UPLOADS' : wrap_class += ' image-float ';
                break;

            case 'AUDIO' : wrap_class += ' voice-float audio-player';
                break;
            case 'VIDEO' : wrap_class += ' video-float audio-player ';
                break;
            default : wrap_class += ' image-float';
                break;

        }

        this.setState({ wrap_class : wrap_class });

        const container = document.querySelector('.right-bottom-area');
        container.addEventListener('scroll', this.listenToScroll)
    }

    showVgallery(typ){
        this.setState({drop_typ:!this.state.drop_typ,g_typ : typ});
        if(typ =='IMG'){
            this.setState({view_type : 'Image'});
        } else if(typ =='VDO'){
            this.setState({view_type : 'Video'});
        } else {
            this.setState({view_type : 'Audio'});
        }

		 let data ={
            'userid' : this.Auth.getProfile().user_id,
            'le_id' : this.props.vigntid
        }

        this.props.getGalleryList(data);

    }

    showModal() {
        this.setState({showModal : true});
    }
    setDropdownOpen = () => {
        this.setState({ dropdownOpen : !this.state.dropdownOpen})
    }

    render() {

        let vignetsGallery = this.props.vignetsGallery?this.props.vignetsGallery.vignetsGalleryList:'';
        let vignetsGdetails = this.props.vignetsGallery?this.props.vignetsGallery.vignetsGalleryDetail:'';

        return (

            <div>
			  <div className="filter-block">
                <div className="filter-block-wrap">
			

                  <div className="sort-wraper">
                        <label>Sort by: </label>

                      <Dropdown isOpen={this.state.dropdownOpen} toggle={this.setDropdownOpen}>
                          <DropdownToggle className="custom-drop button-adj" caret>
                              {this.state.view_type}
                          </DropdownToggle>
                          <DropdownMenu className="dropdown-menu button-adj">
                              <DropdownItem className="button-adj" onClick={(e) => this.showVgallery('IMG')}>Image</DropdownItem>
                              <DropdownItem className="button-adj" onClick={(e) => this.showVgallery('VDO')}>Video</DropdownItem>
                              <DropdownItem className="button-adj" onClick={(e) => this.showVgallery('AUDIO')}>Audio</DropdownItem>
                          </DropdownMenu>
                      </Dropdown>
                        {/*<Dropdown>

                            <Dropdown.Toggle className="custom-drop button-adj" id="dropdownMenu3" variant="none">
                                {this.state.view_type}
                            </Dropdown.Toggle>

                            <Dropdown.Menu className="dropdown-menu button-adj">
                                <Dropdown.Item className="button-adj" onClick={(e) => this.showVgallery('IMG')}>Image</Dropdown.Item>
                                <Dropdown.Item className="button-adj" onClick={(e) => this.showVgallery('VDO')}>Video</Dropdown.Item>
                                <Dropdown.Item className="button-adj" onClick={(e) => this.showVgallery('AUDIO')}>Audio</Dropdown.Item>
                               
                            </Dropdown.Menu>
                        </Dropdown>*/}

</div>
</div>
                    </div>
                {vignetsGallery.length > 1 ?
                    <GraphicsContainer vignetsGallery={vignetsGallery.filter(list=>list.img_typ===this.state.g_typ)} source="vignets" vgtyp={this.state.g_typ}/> : <p className={"centered-text"}>No items found</p>}


            </div>






        );
    }
}
Gallery.propTypes = {
    gal_type: PropTypes.string
}

function mapStateToProps(state) {

    return {

        galleryData  :state.gallery.galleryData,
        vignetsGallery  :state.vignets.vignetsData,
        galleryUpdate  :state.gallery.galleryUpdate
    };

}
export default  withRouter(connect(mapStateToProps, {
    allGalleryData : galleryActions.galleryData,
    setGalleryType : galleryActions.setType,
    getGalleryList: vignetsActions.getVignetGallery,
    getGalleryDetails : vignetsActions.getVignetGdetail,
})(Gallery));



// WEBPACK FOOTER //
// ./src/components/vignets/Gallery.js